// Borrowed from Campaign Client
export const getCookie = (name) => {
  try {
    // Split cookie string and get all individual name=value pairs in an array
    const cookieArr = document.cookie.split(';')
    let cookieValue = null

    // Loop through the array elements
    for (let i = 0; i < cookieArr.length; i++) {
      const cookiePair = cookieArr[i].split('=')

      if (name == cookiePair[0].trim()) {
        cookieValue = decodeURIComponent(cookiePair[1])
        break
      }
    }

    // If cookie value found, return it
    if (cookieValue) {
      if (name === 'x-auth-token' && window.sessionStorage) {
        sessionStorage.setItem('x-auth-token', cookieValue)
      }
      return cookieValue
    }

    // No value found in cookie or session storage
    return null
  }
  catch (error) {
    console.error('Error getting cookie:', error)
    return null
  }
}

// Returns the registrable domain (e.g. "example.com") or null for public-suffix
// hostnames like "deploy-preview-123--site.netlify.app" where setting a Domain
// attribute would be rejected by the browser.
const getRegistrableDomain = (hostname) => {
  // Known multi-part public suffixes where slice(-2) would yield the TLD itself
  const publicSuffixSecondLevels = ['netlify.app', 'vercel.app', 'pages.dev', 'github.io', 'localhost']
  const lastTwo = hostname.split('.').slice(-2).join('.')
  if (publicSuffixSecondLevels.includes(lastTwo) || !hostname.includes('.')) return null
  return lastTwo
}

export const setCookie = (name, value, options = {}) => {
  try {
    const {
      domain = getRegistrableDomain(window.location.hostname),
      path = '/',
      maxAge = undefined,
      secure = window.location.protocol === 'https:',
      sameSite = 'lax',
    } = options

    let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`

    if (path) cookieString += `; path=${path}`
    if (domain) cookieString += `; domain=${domain}`
    if (maxAge !== undefined) cookieString += `; max-age=${maxAge}`
    if (secure) cookieString += '; secure'
    if (sameSite) cookieString += `; samesite=${sameSite}`

    if (name === 'x-auth-token' && window.sessionStorage) {
      sessionStorage.setItem('x-auth-token', value)
    }

    document.cookie = cookieString
  }
  catch (error) {
    console.error('Error setting cookie:', error)
  }
}

export const deleteCookie = (name, options = {}) => {
  const defaultOptions = {
    path: '/',
    domain: getRegistrableDomain(window.location.hostname),
  }

  const opts = { ...defaultOptions, ...options }

  window.sessionStorage.clear()
  setCookie(name, '', { ...opts, maxAge: 0 })
}
